import React, { useEffect, useState } from "react";
import classes from "./MobilePartnershipProgramCard.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { AthleteImg } from "../../constant/imagePath";
import PropTypes from "prop-types";
import { ReactSVG } from "react-svg";

export const MobilePartnershipProgramCard = ({
  image,
  heading,
  description,
  customStyle,
}) => {
  const headings = heading.split(" ");
  return (
    <div className={classes.card} style={{ ...customStyle }}>
      <h4
        style={{
          ...Fonts.h4,
          fontSize: "20px",
          lineHeight: "28px",
          color: Colors.neutralShadesOfNero,
        }}
      >
        {headings?.length > 0 &&
          headings?.map((item, index) => {
            return (
              <span
                style={{
                  ...Fonts.h4,
                  fontSize: "20px",
                  lineHeight: "28px",
                  color: Colors.neutralShadesOfNero,
                  marginTop: index > 0 ? "10px" : "0px",
                }}
                key={index}
              >
                {item}
              </span>
            );
          })}
      </h4>
      <p
        className={classes.description}
        style={{
          ...Fonts.p1,
          fontSize: "14px",
          color: Colors.neutralShadesOfDimGray,
        }}
      >
        {description}
      </p>
      <div>
        <img src={image} className={classes.img} />
      </div>
      <p
        className={classes.borderBottom}
        style={{ background: Colors.neutralShadesOfGainsboro }}
      />
    </div>
  );
};

MobilePartnershipProgramCard.propTypes = {
  image: PropTypes.string,
  heading: PropTypes.string,
  description: PropTypes.string,
  customStyle: PropTypes.object,
};

MobilePartnershipProgramCard.defaultProps = {
  heading: "Athlete",
  description:
    "All of our coaches have extensive coaching experience and are required to pass rigorous background checks.",
  image: AthleteImg,
};
